import { createSlice } from "@reduxjs/toolkit"


// First, define the reducer and action creators via `createSlice`
const WorkspacesSlice = createSlice({
  name: 'workspaces',
  initialState: {
    loading: 'idle',
    workspaces: []
  },
  reducers: {
    workspacesLoading(state, action) {
      // Use a "state machine" approach for loading state instead of booleans
      if (state.loading === 'idle') {
        state.loading = 'pending'
      }
    },
    workspacesReceived(state, action) {
      if (state.loading === 'pending') {
        state.loading = 'idle'
        state.workspaces = action.payload
      }
    }
  }
})

// Destructure and export the plain action creators
export const { workspacesLoading, workspacesReceived } = WorkspacesSlice.actions

export default WorkspacesSlice

// // Define a thunk that dispatches those action creators
// const fetchWorkspaces = () => async dispatch => {
//   dispatch(workspacesLoading())
//   const response = await workspacesAPI.fetchAll()
//   dispatch(workspacesReceived(response.data))
// }

// const fetchWorkspaceById = createAsyncThunk(
//   'users/fetchByIdStatus',
//   async (userId, thunkAPI) => {
//     const response = await userAPI.fetchById(userId)
//     return response.data
//   }
// )